export default __webpack_public_path__ + "static/media/question_11.32e1fd24.png";